import React from 'react'
import { NoResults } from 'styles/algolia/artwork'
import { ArtworksList as CollectionsList } from '../styles'
import Polaroid from './polaroids/Polaroid'
import type { ConnectorProps as ListProps } from '../../connectors/Collection'
import CollectionConnector from '../../connectors/Collection'
import { displayEllipticalString } from '../../helpers/helperFunctions'
export default CollectionConnector(
  (props: ListProps): React.ReactElement<React.ComponentProps<any>, any> => {
    const { collectionsList } = props

    if (!collectionsList.length) {
      return <NoResults>Sorry, there are no collections to display</NoResults>
    }

    return (
      <CollectionsList>
        {collectionsList.map((collection, index) => {
          const {
            collectionTitle,
            description,
            collectionCount,
            collectionUrl,
            mainImage,
            thumbs,
            collectionOwnerId,
            collectionOwnerName,
            collectionOwnerJobTitle,
            collectionOwnerAvatar,
          } = collection
          const cleanCollectionTitle =
            collectionTitle.length > 50
              ? displayEllipticalString(collectionTitle, 50)
              : collectionTitle
          const cleanDescription =
            description.length > 150 ? displayEllipticalString(description, 150) : description
          return (
            <Polaroid
              collectionTitle={cleanCollectionTitle}
              collectionCount={collectionCount}
              collectionUrl={collectionUrl}
              imageUrl={mainImage}
              thumbs={thumbs}
              index={`collection-public-${index + 1}`}
              avatarUrl={collectionOwnerAvatar}
              curatorName={collectionOwnerName}
              jobTitle={collectionOwnerJobTitle}
              curatorUserId={collectionOwnerId}
              description={cleanDescription}
              key={`collection-public-${index + 1}`}
            />
          )
        })}
      </CollectionsList>
    )
  }
)